import { BooleanState } from "@src/utils/mobx/states/BooleanState";
import { uniqueId } from "lodash";
import { makeObservable } from "mobx";

export class EditableTextStore {
  readonly dataComponentName =
    `editable-text-${uniqueId()}-data-component-name`;
  isEditEnabled = new BooleanState(false);

  constructor() {
    makeObservable(this);
  }
}
